import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/web.dom-collections.for-each";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getDataJson, pollingRefresh } from "@/utils/refreshCptData";
var fileUrl = "";
export default {
  name: "cpt-scroll-table",
  props: {
    option: Object,
    width: Number,
    height: Number,
    show: Boolean
  },
  inject: ['queryParam'],
  watch: {
    'option.attribute.showLine': {
      handler: function handler() {
        this.computeRowHeight();
        this.scrollTable();
      },
      deep: true //深度监听

    },
    width: function width() {
      this.computeColWidth();
    },
    height: function height() {
      this.computeRowHeight();
    },
    show: function show(val) {
      if (val) {
        this.computeColWidth();
      }
    }
  },
  data: function data() {
    return {
      fileUrl: fileUrl,
      colWidths: {},
      rowHeight: 10,
      tableData: [],
      rollData: [],
      cptData: '',
      uuid: null,
      timer: null
    };
  },
  created: function created() {
    this.uuid = require('uuid').v1();
    this.refreshCptData();
  },
  mounted: function mounted() {
    this.computeColWidth();
    this.computeRowHeight();
  },
  methods: {
    computeRowHeight: function computeRowHeight() {
      this.rowHeight = (this.height - this.option.attribute.theadHeight) / this.option.attribute.showLine;
    },
    computeColWidth: function computeColWidth() {
      var that = this;
      that.colWidths = {};
      this.option.attribute.columns.forEach(function (item) {
        that.colWidths[item.colKey] = that.$refs[item.colKey][0].clientWidth;
      });
    },
    refreshCptData: function refreshCptData() {
      pollingRefresh(this.uuid, this.option.cptDataForm, this.loadData);
    },
    loadData: function loadData() {
      var _this = this;

      getDataJson(this.option.cptDataForm, this.queryParam, "ScrollTable").then(function (res) {
        var parse = res;

        for (var i = 0; i < parse.length; i++) {
          parse[i].rowNum = i;
        }

        _this.tableData = parse;

        _this.scrollTable();
      });
    },
    scrollTable: function scrollTable() {
      var that = this;

      if (this.timer) {
        clearInterval(this.timer);
      }

      that.rollData = that.tableData.slice(0, this.option.attribute.showLine);

      if (this.option.attribute.showLine >= that.tableData.length) {
        return;
      }

      var i = this.option.attribute.showLine;
      this.timer = setInterval(function () {
        that.rollData.shift();
        that.rollData.push(that.tableData[i]);
        i++;

        if (i >= that.tableData.length) {
          i = 0;
        }
      }, 2000);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  }
};